// extracted by mini-css-extract-plugin
export default {"link":"oR-z","disabled":"pR-z"};